import React, { Component } from 'react';
import { sendAccessToken } from "../api/index";

class Expire extends Component{
  _sendEmail = () => {
    let body = {type: 'regist', email: this.props.email};
    let tenantname = location.hostname.split('.')[0].split('-')[0];
    sendAccessToken(body, {headers: {'tenantname': tenantname}})
      .then(res=>{
        if (res.status==="success") {
          $.sound_on = false;
          $.bigBox({
            title : "Alert",
            content : "Please go to your email to complete the subscription.",
            color : "#739E73",
            timeout: 6000,
            icon : "fa fa-check",
            number : "Thank you"
          });
        }
      })
      .catch(err=>{
        console.log(err);
      });
  };
  render() {
    return (
      <div id="content" className="container">
        <div className="row" style={{marginTop: 14}}>
          <div className="well col-md-6 col-md-offset-3" style={{padding: '30px 20px', marginTop: 30}}>
            <h1 className="login-header-big tex-color-dangreen text-center" style={{fontWeight: 550, fontSize: 24}}>The hyperlink in your email has expired.</h1>
            <br/>
            <p className="text-center" style={{color: '#000'}}> <strong>Please click <a className="sendAccessToken" href="javascript:"><span style={{textDecoration: 'underline'}} onClick={this._sendEmail}>here</span></a> to send a new 24 hours  access token to your registered email address.</strong></p>
          </div>
        </div>
      </div>
    );
  }
}

export default Expire;


// WEBPACK FOOTER //
// ./src/container/expire.js